var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPopupClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3437 4.70939L14.4531 11.6L21.3437 18.5563C22.1969 19.3438 22.1969 20.7219 21.3437 21.5094C20.5562 22.3625 19.1781 22.3625 18.3906 21.5094L11.5 14.6188L4.54375 21.5094C3.75625 22.3625 2.37812 22.3625 1.59062 21.5094C0.7375 20.7219 0.7375 19.3438 1.59062 18.5563L8.48125 11.6L1.59062 4.70939C0.7375 3.92189 0.7375 2.54376 1.59062 1.75626C2.37812 0.903138 3.75625 0.903138 4.54375 1.75626L11.5 8.64689L18.3906 1.75626C19.1781 0.903138 20.5562 0.903138 21.3437 1.75626C22.1969 2.54376 22.1969 3.92189 21.3437 4.70939Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPopupClose);
export default __webpack_public_path__ + "static/media/popup-close.20242076df0607e82b0da17be20f4af5.svg";
export { ForwardRef as ReactComponent };